import { render, staticRenderFns } from "./CategoryDetail.vue?vue&type=template&id=4417d154&"
import script from "../../../services/admin/category/category-detail.js?vue&type=script&lang=js&"
export * from "../../../services/admin/category/category-detail.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports